module.exports = __webpack_public_path__ + "static/img1-198f54b31e5c0d2fa6a5f8d334489a57.png";